<template>
  <div class="main">
    <div class="header">
      <div>
        <h2>Rent Steel Storage Containers</h2>
        <h4>
          Enter the postal code where your shipping container(s) will be
          delivered
        </h4>
      </div>
    </div>
    <input
      class="form shadow-5"
      list="zipcodes"
      placeholder="Postal Code"
      style="width: 150px"
      type="text"
      v-model="Bind_Zipcode"
    />
    <datalist id="zipcodes">
      <option :key="index" v-for="(zipcode, index) in zipcodesList">
        {{ zipcode }}
      </option>
    </datalist>
    <br />
    <!-- ERROR MESSAGING  -->
    <div id="errormessage"></div>
    <!-- Redirect Loader -->
    <v-overlay :value="redirectLoader">
      <div class="loader">Loading...</div>
      <small>Redirecting .....</small>
      <div id="redirect_loader"></div>
    </v-overlay>

    <div class="row justify-content-center" style="margin-top: 40px">
      <invisible-recaptcha
        sitekey="6LeGZNEZAAAAANSEr40O2tnjd5UGN31gYQu3PjDQ"
        :callback="submitted"
        class="btn btn-primary btn-grad"
        type="submit"
        id="submit_button"
        v-bind:disabled="!zipCodeValid()"
        >Rental Prices
        <v-icon right color="#ffffff"> mdi-arrow-right-thick </v-icon>
      </invisible-recaptcha>
    </div>
    <br />
    <!--Loader starts -->
    <v-dialog hide-overlay persistent top v-model="loader" width="500px">
      <v-card
        style="
          background: linear-gradient(#6dbe45, #3b701e);
          border-radius: 20px;
        "
      >
        <br />
        <textarea
          :value="loaderMessage"
          class="marketsLoader"
          cols="40"
          readonly
          rows="2"
          type="text"
        />
        <v-card-text>
          <div class="loader">Loading...</div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--Loader ends -->
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import * as types from "../store/types";
import InvisibleRecaptcha from "vue-invisible-recaptcha";

export default {
  name: "Home",
  components: {
    "invisible-recaptcha": InvisibleRecaptcha,
  },
  computed: {
    //Store - vuex getters.
    ...mapGetters({
      VuexZipcode: types.ZIPCODE,
      VuexCartItem: types.CARTLINEITEM,
      PreDeliveryAnswers: types.PREDELIVERYANSWERS,
      VuexTermsConditions: types.TERMSNCONDITIONS,
      VuexRentalContainersList: types.RENTALCONTAINERSLIST,
      COUNTRY_CODE: types.COUNTRY_CODE,
    }),
    Bind_Zipcode: {
      //Bind vuex zipcode.
      get() {
        return this.VuexZipcode;
      },
      set(value) {
        this.setVuexZipcode(value);
      },
    },
  },
  data() {
    return {
      loader: false,
      loaderMessage: "",
      markets: [],
      zipcodesList: [],
      redirectLoader: false,
    };
  },
  mounted() {
    this.zipcodesList = JSON.parse(localStorage.getItem("zipcodesList"));
    if (this.$route.query.postal_code) {
      this.setVuexZipcode(this.$route.query.postal_code);
      localStorage.zipcode = this.VuexZipcode;
    }
  },
  methods: {
    //Store - vuex actions > mutations.
    ...mapActions({
      setVuexZipcode: types.ACTIONS_UPDATE_ZIPCODE,
      setVuexRentalContainersList: types.ACTIONS_UPDATE_RENTALCONTAINERSLIST,
      setVuexTermsConditions: types.ACTIONS_UPDATE_TERMSNCONDITIONS,
      deleteCartItem: types.ACTIONS_UPDATE_EMPTYCART,
      setPredeliveryDefault: types.ACTIONS_UPDATE_PREDELIVERYANSWERSDEFAULT,
    }),
    zipCodeValid() {
      const US_Regex = RegExp("^[0-9]{5}$");
      const Canada_Regex = RegExp("^[A-Za-z0-9]{3}[ ]?[A-Za-z0-9]{3}$");

      return (
        Canada_Regex.test(this.VuexZipcode) || US_Regex.test(this.VuexZipcode)
      );
    },
    submitted(response) {
      /*resposne will have the reCAPTCHA token.
      If token is null or empty do nothing.*/
      if (!response) return;
      document.getElementById("errormessage").innerHTML = "";
      localStorage.zipcode = this.VuexZipcode;
      axios
        .get(
          "https://8bikxb8159.execute-api.us-west-2.amazonaws.com/prod/sale-prices",
          {
            headers: {
              "X-API-Key": "o6oTAepBiP5JngNwbFdLu6MN6HMYLNPN6IYQxedV",
            },
            params: {
              postal_code: this.VuexZipcode,
              country: this.COUNTRY_CODE,
              order_type: "Rental",
            },
          }
        )
        .then((response) => this.addhaulerdetails(response.data))
        .catch((err) => {
          console.log(err);
          this.loader = false;
        });
      //get loading message started with some "searching....." text
      this.getLoaderStarted();
    },
    addhaulerdetails(response) {
      /*If data is not present in server response,
        then just display error message to user and close the loader popup.*/
      if (!("data" in response)) {
        this.loader = false;
        let errorMessage = response.responses[0].elements[0].replace(
          "Error:",
          ""
        );
        let extractedUrls = errorMessage.match(/\bhttps?:\/\/\S+/gi);
        if (extractedUrls && extractedUrls.length > 0)
          this.handleRedirection(
            extractedUrls[0].replaceAll("'", ""),
            errorMessage
          );
        else document.getElementById("errormessage").innerHTML = errorMessage;
      } else {
        document.getElementById("errormessage").innerHTML = "";
        //maintain zipcodes List in local storage. Max-size is 5.
        this.zipcodesLocalStorage();
        this.resetDefault(); //Set everything to default.
        this.setVuexRentalContainersList(response.data);
        this.markets = response.data.markets;
        this.maintainLocalStorage();
        this.getMarketsLoader();
        this.maintainSessionStorage();
      }
    },
    handleRedirection(url, errorMessage) {
      this.redirectLoader = true;
      setTimeout(() => {
        document.getElementById("redirect_loader").innerHTML = errorMessage;
      }, 100);
      setTimeout(() => {
        this.redirectLoader = false;
        window.location.href = `${url}?postal_code=${this.VuexZipcode}`;
      }, 3000);
    },
    resetDefault() {
      //Change values to default
      this.setVuexTermsConditions(false);
      this.deleteCartItem();
      this.setPredeliveryDefault();
    },
    getLoaderStarted() {
      this.loader = true;
      this.loaderMessage = "Searching your area for best prices...";
    },
    getMarketsLoader() {
      /*Display all the markets return in the response on the loader popup
       with some time -gap between each market display.*/
      var count = 0;
      for (var i = 0; i < this.markets.length; i++) {
        setTimeout(() => {
          this.setMessage(count);
          count += 1;
        }, i * 1200);
      }
    },
    setMessage(count) {
      document.getElementsByClassName("marketsLoader")[0].value =
        "Comparing prices from " + this.markets[count] + "...";
      if (count === this.markets.length - 1) {
        setTimeout(() => {
          //When the last element of markets list is encountered then navigate to select containers page.
          this.loader = false;
          this.navigate();
        }, 1200);
      }
    },
    navigate() {
      this.$router.push("/rentals");
    },
    zipcodesLocalStorage() {
      //check if zipcodeList present  in localstorage
      if (!("zipcodesList" in localStorage))
        localStorage.setItem(
          "zipcodesList",
          JSON.stringify([this.VuexZipcode])
        );
      else {
        var zipcodesList = JSON.parse(localStorage.getItem("zipcodesList"));
        //check if zipcode is present already in the list
        if (zipcodesList.includes(this.VuexZipcode)) return;
        else {
          //check if the size is less than 5. If not change the least recently used zipcode(Queue - First In First Out)
          if (zipcodesList.length < 5) zipcodesList.push(this.VuexZipcode);
          else {
            zipcodesList.shift();
            zipcodesList.push(this.VuexZipcode);
          }
          localStorage.setItem("zipcodesList", JSON.stringify(zipcodesList));
        }
      }
    },
    maintainLocalStorage() {
      //Maintain local storage with zipcode, cart line item(set to default- empty) and containers list
      const cartItem = JSON.stringify(this.VuexCartItem);
      localStorage.setItem("cartItem", cartItem);
      const containersList = JSON.stringify(this.VuexRentalContainersList);
      localStorage.setItem("containersList", containersList);
    },
    maintainSessionStorage() {
      //Maintain session storage with Profile Question's answers and terms and conditions which were set to default.
      const PreDeliveryAnswers = JSON.stringify(this.PreDeliveryAnswers);
      sessionStorage.setItem("PreDeliveryAnswers", PreDeliveryAnswers);
      const Terms_Conditions = JSON.stringify(this.VuexTermsConditions);
      sessionStorage.setItem("Terms_Conditions", Terms_Conditions);
    },
  },
};
</script>

<style scoped>
@import url(https://maxcdn.bootstrapcdn.com/font-awesome/4.4.0/css/font-awesome.min.css);

.main {
  margin: auto;
  width: 20%;
  margin-top: 120px;
  color: #ffffff;
}

@media only screen and (max-width: 550px) {
  .main {
    width: 90%;
  }
}

.header {
  margin-bottom: 50px;
}

textarea {
  width: 90%;
  border: none;
  outline: none;
  resize: none;
}

.marketsLoader {
  font-size: 15px;
  text-align: center;
  color: #ffffff;
}

.form {
  border-radius: 25px;
  margin: auto;
  width: 25%;
  padding: 10px;
  color: black;
  background-color: white;
  text-align: center;
  font-size: 18px;
  /* box-shadow: inset 0px 0px 0 2000px rgba(0, 0, 0, 0.15); */
}

input {
  text-align: center;
  font-size: 14pt;
  border-style: inherit;
}

#errormessage {
  font: outline;
  font-size: 18px;
  padding: 10px;
  font-weight: bolder;
  color: lightyellow;
  font-style: oblique;
  width: 90%;
  display: inline-block;
}

h2 {
  font-size: 25px;
  font-weight: bold;
}

h4 {
  font-size: 17px;
  font-weight: bold;
}

.btn-grad {
  margin: 35px;
  height: 50px;
  width: 200px;
  color: #ffffff;
  text-decoration: none;
  text-transform: unset !important;
  border-radius: 20px;
  font-weight: 900;
  box-shadow: 1px 1px 1px 1px #ffffff;
  background-image: linear-gradient(to bottom, #6dbe45 0%, #3b701e 100%);
}

.btn-grad i {
  max-width: 0;
  transition: max-width 0.5s;
  display: inline-block;
  vertical-align: top;
  white-space: nowrap;
  overflow: hidden;
}

.btn-grad:hover i {
  max-width: 10rem;
  transition-delay: 0.1s;
}

.loader,
.loader:before,
.loader:after {
  background: #ffffff;
  -webkit-animation: load1 1s infinite ease-in-out;
  animation: load1 1s infinite ease-in-out;
  width: 1em;
  height: 2em;
}
.loader {
  color: #ffffff;
  text-indent: -9999em;
  margin: 40px auto;
  position: relative;
  font-size: 11px;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}
.loader:before,
.loader:after {
  position: absolute;
  top: 0;
  content: "";
}
.loader:before {
  left: -1.5em;
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}
.loader:after {
  left: 1.5em;
}
@-webkit-keyframes load1 {
  0%,
  80%,
  100% {
    box-shadow: 0 0;
    height: 2em;
  }
  40% {
    box-shadow: 0 -2em;
    height: 3em;
  }
}
@keyframes load1 {
  0%,
  80%,
  100% {
    box-shadow: 0 0;
    height: 2em;
  }
  40% {
    box-shadow: 0 -2em;
    height: 3em;
  }
}
</style>
